import { Suspense } from 'react'
import UserInfoLayout from './UserInfo'
import DataStoreLayout from './DataStore'
import RouterLayout from './Router'
import { FaWindows } from 'react-icons/fa'
import { I18n } from "aws-amplify";
import { Translations } from "@aws-amplify/ui-components";
import { AWSIoTProvider } from '@aws-amplify/pubsub';

import '../App.css';

// Amplify
import Amplify, { Auth } from 'aws-amplify'
import { Authenticator, Divider } from '@aws-amplify/ui-react';
import awsconfig from '../aws-exports-ext'
import '@aws-amplify/ui-react/styles.css'; // default theme
import { getUser } from '../apis'
import wrapPromise from '../helpers/wrapPromise'

Amplify.Logger.LOG_LEVEL = 'ERROR'
Amplify.configure(awsconfig)

Amplify.addPluggable(new AWSIoTProvider({
  aws_pubsub_region: awsconfig.aws_pubsub_region,
  aws_pubsub_endpoint: awsconfig.aws_pubsub_endpoint,
}))

I18n.putVocabulariesForLanguage("en-US", {
  [Translations.USERNAME_LABEL]: 'ชื่อผู้ใช้งาน',
  [Translations.USERNAME_PLACEHOLDER]: 'กรอกชื่อผู้ใช้งาน',
  [Translations.PASSWORD_LABEL]: 'รหัสผ่าน',
  [Translations.PASSWORD_PLACEHOLDER]: 'ใส่รหัสผ่าน',
  [Translations.SEND_CODE]: 'ส่งรหัสยืนยันตัวตน',
  [Translations.CHANGE_PASSWORD]: 'ตั้งรหัสผ่านใหม่',
  [Translations.CHANGE_PASSWORD_ACTION]: 'ยืนยัน',
  [Translations.BACK_TO_SIGN_IN]: 'กลับไปหน้า Sign In',
  [Translations.NEW_PASSWORD_LABEL]: 'รหัสผ่านใหม่ จะต้องมีความยาวขั้นต่ำ 8 ตัวอักษร',
  [Translations.NEW_PASSWORD_PLACEHOLDER]: 'ตั้งรหัสผ่านใหม่',
  [Translations.SIGN_IN_TEXT]: "เข้าสู่ระบบ",
  [Translations.FORGOT_PASSWORD_TEXT]: "ลืมรหัสผ่าน ?",
  [Translations.SIGN_UP_USERNAME_PLACEHOLDER]: "รหัสพนักงาน 6 หลัก",
  [Translations.SIGN_UP_PASSWORD_PLACEHOLDER]: "รหัสผ่าน ขั้นต่ำ 8 ตัวอักษร"
})

const AuthLayout = () => {
  const fetchUserProfile = (username) => {
    const userPromise = getUser(username);
    return wrapPromise(userPromise)
  }

  return <Authenticator
    loginMechanisms={['username', 'email']}
    components={{
      SignIn: {
        Header() {
          return <div className='px-5 pt-5 text-center fle'>
            <div className='flex justify-center p-4'>
              <img
                alt="NEO logo"
                src={window.location.origin + `/images/NEO.png`}
              />
            </div>
            <h5 className='pb-4 font-bold'>DIGITAL PRODUCTION - {process.env.REACT_APP_ENV}</h5>
            <button onClick={() => Auth.federatedSignIn()} className="mb-6 btn-signin-ms w-fit">
              <FaWindows /><span>&nbsp;&nbsp;เข้าระบบด้วย EMAIL บริษัท</span>
            </button>
            <Divider size="small" label='or' />
          </div>
        }
      }
    }}
    hideSignUp={true}
    >
    {({ signOut, user }) => {
      const usergroups = (user.getSignInUserSession().getAccessToken().payload['cognito:groups'] || [])
        .filter(group => !group.startsWith('ap-southeast-1'))

      const userGroup = usergroups[0] || ''
      const userProfile = fetchUserProfile(user.username);

      return <Suspense fallback={<h6>Loading profile...</h6>}>
        <div className={`App${process.env.NODE_ENV === 'development' ? ' debug-screens' : ''}`}>
          <UserInfoLayout ps={userProfile} userGroup={userGroup} cognitoUser={user} >
            <DataStoreLayout >
              <RouterLayout />
            </DataStoreLayout>
          </UserInfoLayout>
        </div>
      </Suspense>
    }}
  </Authenticator>
}

export default AuthLayout